import { render, staticRenderFns } from "./OcpcSetting.vue?vue&type=template&id=e04eae1e"
import script from "./OcpcSetting.vue?vue&type=script&lang=js"
export * from "./OcpcSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports